import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import DepartmentCarousel from '../../Slider/DepartmentCarousel';

// Same as home Hero overlay so bg image is visible in the back ($primaryDark / $bodyBg)
const HERO_STYLE_OVERLAY = 'linear-gradient(135deg, rgba(3, 16, 30, 0.92) 0%, rgba(10, 15, 26, 0.85) 100%)';

export default function DepartmentSection({ sectionTitle, bgUrl, data, className }) {
  const bgStyle = bgUrl
    ? {
        backgroundImage: `${HERO_STYLE_OVERLAY}, url(${bgUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        padding: '60px 40px',
        borderRadius: '15px',
      }
    : {
        backgroundColor: '#e6f2ff',
        background: 'linear-gradient(135deg, #e6f2ff 0%, #d9ecff 50%, #cce5ff 100%)',
        padding: '60px 40px',
        borderRadius: '15px',
      };

  return (
    <div className="container">
      <div className={`cs_departments cs_style_1 ${bgUrl ? 'cs_has_bg_image' : ''} ${className || ''}`}>
        <div
          className="cs_departments_bg cs_radius_25"
          style={bgStyle}
        />
        <SectionHeading title={sectionTitle} center />
        <Spacing md="72" lg="50" />
        <div className="cs_department_list">
          <DepartmentCarousel data={data} />
        </div>
      </div>
    </div>
  );
}
